import React from "react";

import classes from "./style/PageLogin.module.css";
import Login from "../../components/Login/Login";
import { SupportEmail } from "../../components/SupportEmail/SupportEmail";

const styles: React.CSSProperties = { textAlign: "center" };

export const PageLogin = () => {
  const textSupport =
    "По всем возникшим трудностям и вопросам вы можете обратиться в техподдержку по адресу";

  const PageLoginInner = () => {
    return <h1 style={styles}>Вход</h1>;
  };

  const Page = () => {
    return <Login />;
  };

  const LoginPage = () => {
    return (
      <>
        <div className={classes.wrapperLogin}>
          <Page />
          <div style={{ marginTop: "20px" }}>
            <SupportEmail text={textSupport} align="center" />
          </div>
        </div>
      </>
    );
  };

  return (
    <div className={classes.formContainer}>
      <PageLoginInner />
      <LoginPage />
    </div>
  );
};
